import axios from "axios";
axios.defaults.baseURL = 'https://apiabigail.buqkly.com/api';
//axios.defaults.baseURL = 'http://127.0.0.1:8000/api/';
